<template>

  <RadioGroup v-model="selected_value" class="mt-2">
    <div class="grid grid-cols-3 gap-3">
      <RadioGroupOption
        as="template"
        v-for="(exportation_type) in exportation_types"
        :key="exportation_type.id"
        :value="exportation_type.id"
        v-slot="{ active, checked }"
      >
        <div
          :class="[
            'cursor-pointer focus:outline-none',
            active
              ? 'ring-2 ring-offset-2 ring-'+(exportation_type.color)+'-500'
              : '',
            checked
              ? 'bg-'+(exportation_type.color)+'-100 border-transparent text-'+(exportation_type.color)+'-800 hover:bg-'+(exportation_type.color)+'-100'
              : 'bg-white border-gray-200 text-gray-900 hover:bg-gray-50',
            'border rounded-md py-1 px-1 flex items-center justify-center text-sm font-medium sm:flex-1',
          ]"
        >
          <RadioGroupLabel as="span">
            <i :class="exportation_type.icon"></i><span class="space-icon"></span>{{ exportation_type.name }}
          </RadioGroupLabel>
        </div>
      </RadioGroupOption>
    </div>
  </RadioGroup>
</template>

<script>
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from "@headlessui/vue";

export default {
  ame: "AEProductionBasicContainerExportExportationTypeSelector",
  components: { RadioGroup, RadioGroupLabel, RadioGroupOption },
  props: ["modelValue"],
  data() {
    return {
      selected_value: this.modelValue,
      exportation_types: [
        {id: 0, name: 'Marítimo', color: 'blue', icon: 'fa-solid fa-ship'},
        {id: 1, name: 'Aéreo', color: 'blue', icon: 'fa-solid fa-plane-departure'},
      ]
    };
  },
  updated() {
    this.selected_value = this.modelValue;
  },
  watch: {
    selected_value: function (newValue) {
      this.$emit("update:modelValue", newValue);
    },
  },
};
</script>